export default __webpack_public_path__ + "static/media/swiggy1.f37d0410.svg";